import { MyReactTable } from './ReactTable';

export default MyReactTable;
